import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import { api } from "@/lib/api";

export const PaymentSuccess = () => {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [state, setState] = useState("checking");
  const [label, setLabel] = useState("");

  useEffect(() => {
    if (!sessionId) { setState("error"); return; }
    let tries = 0;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        setLabel(data.session_label || "");
        if (data.payment_status === "paid") { setState("paid"); return; }
        if (data.payment_status === "expired" || data.payment_status === "failed") { setState("error"); return; }
      } catch { /* keep trying */ }
      if (tries++ < 8) setTimeout(poll, 2000);
      else setState("pending");
    };
    poll();
  }, [sessionId]);

  return (
    <div className="min-h-screen flex items-center justify-center px-6 relative z-10 pt-20" data-testid="payment-success-page">
      <div className="max-w-md w-full bg-[#121212] border border-white/10 rounded-2xl p-10 text-center">
        {state === "checking" && <><Loader2 className="mx-auto mb-5 animate-spin text-[#C19A5B]" size={44} /><h1 className="font-display text-2xl text-white">Verifica del pagamento…</h1></>}
        {state === "paid" && <><CheckCircle2 className="mx-auto mb-5 text-[#C19A5B]" size={52} /><h1 className="font-display text-3xl text-white mb-3">Pagamento confermato!</h1><p className="text-zinc-400">{label && `${label}. `}Grazie! Riceverai a breve la conferma della tua sessione. Ti aspetto.</p></>}
        {state === "pending" && <><Loader2 className="mx-auto mb-5 animate-spin text-[#C19A5B]" size={44} /><h1 className="font-display text-2xl text-white mb-3">Pagamento in elaborazione</h1><p className="text-zinc-400">Sta impiegando qualche istante. Ti invieremo la conferma via email.</p></>}
        {state === "error" && <><XCircle className="mx-auto mb-5 text-red-400" size={52} /><h1 className="font-display text-2xl text-white mb-3">Qualcosa è andato storto</h1><p className="text-zinc-400">Non siamo riusciti a verificare il pagamento. Contattaci pure.</p></>}
        <Link to="/" className="inline-block mt-8 rounded-full bg-[#C19A5B] text-black font-semibold px-6 py-3 hover:bg-[#D4AF37] transition-colors">Torna alla home</Link>
      </div>
    </div>
  );
};

export const PaymentCancel = () => (
  <div className="min-h-screen flex items-center justify-center px-6 relative z-10 pt-20" data-testid="payment-cancel-page">
    <div className="max-w-md w-full bg-[#121212] border border-white/10 rounded-2xl p-10 text-center">
      <XCircle className="mx-auto mb-5 text-zinc-500" size={52} />
      <h1 className="font-display text-2xl text-white mb-3">Pagamento annullato</h1>
      <p className="text-zinc-400">Nessun addebito effettuato. Puoi riprovare quando vuoi.</p>
      <Link to="/prenota" className="inline-block mt-8 rounded-full bg-[#C19A5B] text-black font-semibold px-6 py-3 hover:bg-[#D4AF37] transition-colors">Torna a prenotare</Link>
    </div>
  </div>
);
